import React from "react";
import { BsLinkedin, BsFacebook } from "react-icons/bs";
import { IoLogoTwitter } from "react-icons/io";

const HeaderSocials = () => {
  return (
    <div className="header_Socials">
      <a href="https://facebook.com/smichi.jb" target="_blank" rel="noreferrer">
        <BsFacebook />
      </a>
      <a href="https://www.linkedin.com/in/smichi" target="_blank" rel="noreferrer">
        <BsLinkedin />{" "}
      </a>
      <a href="https://twitter.com" target="_blank" rel="noreferrer">
        <IoLogoTwitter />
      </a>
    </div>
  );
};

export default HeaderSocials;
